import fr from 'facet-rest';
import { GoalDetailOverride } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/MetaOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import BigPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/BigPicklistControl';

export const PayOffDebtOverride = fr.metaOverride({ base: GoalDetailOverride })
  .nameOverride('debtPayOffPreference', {
    _component: () => BigPicklistControl,
  }, overrideReadOnly);
